var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyInboxAndError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 110C87.6094 110 110 87.6271 110 60C110 32.3729 87.6094 10 60 10C32.3906 10 10 32.3729 10 60C10 87.6271 32.3906 110 60 110Z",
    fill: "#D5DFF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2633 55.5617V79.1235C89.2633 84.0186 85.282 87.9999 80.3216 87.9999H38.9417C34.0466 87.9999 30.0653 84.0839 30 79.1888C30 79.1235 30 79.1235 30 79.0582V55.5617C30 55.4965 30 55.4965 30 55.4312C30 55.3007 30 55.1701 30.0653 55.0396C30.1305 54.8438 30.1958 54.7133 30.2611 54.5175L41.3566 33.3054C41.7482 32.4569 42.5967 32 43.5105 32H75.6876C76.6013 32 77.3846 32.4569 77.8414 33.3054L88.937 54.5175C89.0023 54.648 89.0675 54.8438 89.1328 55.0396C89.2633 55.1701 89.2633 55.3659 89.2633 55.5617Z",
    fill: "#F3F4F6",
    stroke: "#BEC6D9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2633 55.5617V81.5384C89.2633 85.1281 86.3915 87.9999 82.7365 87.9999H36.5268C32.9371 87.9999 30 85.1281 30 81.5384V55.4312C30 55.3006 30 55.1701 30.0653 55.0396H44.9464C47.1655 55.0396 48.993 56.8018 48.993 59.0862C48.993 60.1957 49.4499 61.24 50.1678 61.958C50.951 62.7412 51.8648 63.1328 53.0396 63.1328H66.289C68.5081 63.1328 70.3356 61.3705 70.3356 59.0862C70.3356 57.9766 70.7925 56.9323 71.5104 56.2144C72.2937 55.4312 73.2074 55.0396 74.317 55.0396H89.1328C89.2633 55.1701 89.2633 55.3659 89.2633 55.5617Z",
    fill: "white",
    stroke: "#BEC6D9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5564 77.2615H36.0386C35.5793 77.2615 35.1855 76.9334 35.1855 76.4085C35.1855 75.9491 35.5137 75.5554 36.0386 75.5554H49.4252C49.8845 75.5554 50.2782 75.8835 50.2782 76.4085C50.3439 76.8022 49.9501 77.2615 49.5564 77.2615Z",
    fill: "#BEC6D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5193 81.3956H36.0386C35.5793 81.3956 35.1855 81.0675 35.1855 80.5425C35.1855 80.0832 35.5137 79.6895 36.0386 79.6895H43.4537C43.9131 79.6895 44.3068 80.0176 44.3068 80.5425C44.3724 80.9362 43.9787 81.3956 43.5193 81.3956Z",
    fill: "#BEC6D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInboxAndError);
export default __webpack_public_path__ + "static/media/empty-inbox-and-error.6d5f44fe45a7d99fa9cb606826b90bc4.svg";
export { ForwardRef as ReactComponent };